<template>
  <div>
    <div class="wrapper-section">
      <div class="step step-3">
        <div class="step__title step-3__title">Страховой полис почти&nbsp;готов!</div>
        <div class="step__subtitle step-3__subtitle">Проверьте Ваши данные</div>
        <div class="step__data">
          <div class="step__data-line">
            <div>Статус страхователя</div>
            <div>{{ form.type }}</div>
          </div>
          <div class="step__data-line">
            <div>ИНН организации</div>
            <div>{{ form.INN }}</div>
          </div>
          <div class="step__data-line">
            <div>Название организации</div>
            <div>{{ response? response.org_name : '' }}</div>
          </div>
          <div class="step__data-line">
            <div>E-mail</div>
            <div>{{ form.email }}</div>
          </div>
          <div class="step__data-line">
            <div>Номер телефона</div>
            <div>{{ form.tel }}</div>
          </div>
          <div class="step__data-line">
            <div>Адрес сайта</div>
            <div>{{ form.site }}</div>
          </div>
          <div class="step__data-line">
            <div>Тариф</div>
            <div>{{ form.tariff }}</div>
          </div>
        </div>
        <div class="step__aftertext">
          Нажимая кнопку «Оплатить», я подтверждаю корректность введенных данных и ознакомление с условиями страхования,  содержащимися в 
          <a class="red" target="_blank" href='/docs/obrazets_dogovora_dlya_yumani.pdf'>Договоре</a>
           и 
           <a class="red" target="_blank" href='/docs/pravila_kombinirovannogo_strakhovaniya_riskov_vladeltsev_biznesa.pdf'>Правилах страхования</a>
        </div>
        <Btn tag="a" class="step__button step-3__button" @click.prevent="sberPay()">Оплатить через СберБизнес</Btn>
        <a class="step-3__link" @click.prevent="otherBankPay()">Оплатить переводом через другой банк</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Btn from './Btn.vue'
export default {
  components: { Btn },
  data: ()=>({
    actions: {}
  }),
  methods: {
    sberPay(){
      if (!this.actions.sberPay) {
        this.actions.sberPay = true
        this.$store.dispatch('callAction','sberPay')
      }
      this.$store.dispatch('payButtonPress','sberPay')
    },
    otherBankPay(){
      if (!this.actions.otherBankPay) {
        this.actions.otherBankPay = true
        this.$store.dispatch('callAction','otherBankPay')
      }
      this.$store.dispatch('payButtonPress','otherBankPay')
    }
  },
  computed: {
    ...mapState(['form', 'response'])
  }
}
</script>

<style lang="sass">
.step
  &-3
    &__title
      margin-bottom: 23px
    &__subtitle
      margin-bottom: 63px
      @include for-mob
        margin: 16px auto
    & &__button
      margin: 31px auto 
      padding-left: 0px
      padding-right: 0px
    &__link
      cursor: pointer
      text-align: center
      margin: 32px auto
      width: fit-content
      text-align: center
      max-width: 100%
      display: block
      color: colors.$gray5
      font-size: 16px
      line-height: 1.12
      position: relative
      &:hover, &:active
        color: colors.$newred
        &::after 
          background: colors.$newred
      @include for-mob 
        text-decoration: underline
        &::after
          display: none !important
      &::after
        content: ''
        position: absolute
        bottom: 0
        background: colors.$gray5
        width: 100%
        height: 1px
        left: 0

  &__data
    width: 806px
    max-width: 100%
    margin: 0 auto
    &-line
      display: flex
      justify-content: space-between
      padding: 19px
      color: colors.$gray5
      font-size: 16px
      line-height: 1.12
      border-bottom: 1px colors.$anothersilver solid
      >*
        width: calc(50% - 16px)
        &:last-child
          font-weight: 500
          color: colors.$gray3
      @include for-mob
        display: block
        padding: 8px 16px 4px
        >*
          padding: 2px 0
          width: 100%

  &__aftertext
    font-size: 11px
    line-height: 1.12
    text-align: center
    width: 700px
    max-width: 100%
    margin: 78px auto 31px
    @include for-mob
      margin: 32px auto 30px
    .red
      &, &:hover, &:active
        color: colors.$newred


</style>